module.exports = __webpack_public_path__ + "img/Skirt-Back-B7-Db-Fc-Hc.205fb665.png";